import { updateSettingNotifications } from "stores/slice/bogus/settingNotifications/const";

const settingNotificationsConfig = {
  // read notification setting
  // API/gluon/organizations => /ents/{entId}/orgs/{orgId}/settings/notification
  "/ents/:entId/orgs/:orgId/settings/notification.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/settings/notification",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "settingNotifications",
  },
  // API/gluon/organizations => /orgs/{orgId}/settings/notification (standalone)
  "/orgs/:orgId/settings/notification.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/settings/notification",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "settingNotifications",
  },
  // API/gluon/site => /ents/{entId}/orgs/{orgId}/sites/{siteId}/settings/notification
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/notification.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/notification",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "settingNotifications",
  },
  // API/gluon/site => /orgs/{orgId}/sites/{siteId}/settings/notification (standalone)
  "/orgs/:orgId/sites/:siteId/settings/notification.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/notification",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "settingNotifications",
  },
  // org update events
  // API/gluon/organizations => /ents/{entId}/orgs/{orgId}/settings/notification
  "/ents/:entId/orgs/:orgId/settings/notification.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/settings/notification",
    restful: true,
    method: "update",
    buildParams: null,
    action: updateSettingNotifications,
    mockSelector: "settingNotifications",
  },
  // API/gluon/organizations => /orgs/{orgId}/settings/notification (standalone)
  "/orgs/:orgId/settings/notification.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/settings/notification",
    restful: true,
    method: "update",
    buildParams: null,
    action: updateSettingNotifications,
    mockSelector: "settingNotifications",
  },
  // site update events
  // API/gluon/site => /ents/{entId}/orgs/{orgId}/sites/{siteId}/settings/notification
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/notification.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/notification",
    restful: true,
    method: "update",
    buildParams: null,
    action: updateSettingNotifications,
    mockSelector: "settingNotifications",
  },
  // API/gluon/site => /orgs/{orgId}/sites/{siteId}/settings/notification (standalone)
  "/orgs/:orgId/sites/:siteId/settings/notification.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/notification",
    restful: true,
    method: "update",
    buildParams: null,
    action: updateSettingNotifications,
    mockSelector: "settingNotifications",
  },
};

export default settingNotificationsConfig;
